<div class="card-light-container">
  <cel-icon
    class="realize-logo"
    data-aria-label="Savvas Realize Logo"
    data-src="./assets/logo/logo_realize_dark.svg"
    [dialogCloseIconRole]="logoImageRole"
  >
  </cel-icon>
  <div class="prelogin-container">
    <div class="text-content">
      <h1 class="slogan">{{ slogan }}</h1>
      <p class="subheading-mesage">
        {{ subheading }}
      </p>
    </div>
    <div class="button-group">
      <cel-button
        id="sign-in-button"
        data-label="{{ signInLabel }}"
        (click)="onSignInButtonClick()"
        [attr.data-aria-label]="signInLabel"
      >
      </cel-button>
      <cel-button
        id="register-button"
        data-variant="text"
        data-label="{{ registerLabel }}"
        (click)="onRegisterButtonClick()"
        [attr.data-aria-label]="registerLabel"
      ></cel-button>
    </div>
  </div>
</div>
